import React from "react";
import PrimaryBttn from "./primaryButton/primaryBttn";
import SecondaryBttn from "./secondaryButton/secondaryBttn";
import { IButton } from "./interface/button";

const Button = ({
  isPrimary = false,
  textBttn = "Button",
  handleClick = () => {},
  isDisabled,
  disabled,
  isLoading = false,
  width,
  fontSize,
  style,
  padding,
  testId,
  color = "#937cf4",
  id,
  buttonProps,
  size = "md",
}: IButton) => {
  // La variante compacta solo rellena lo que el llamador no fijó: quien ya
  // pasa padding/fontSize propios mantiene su render intacto.
  const isSmall = size === "sm";
  const resolvedPadding = padding ?? (isSmall ? "0 14px" : undefined);
  const resolvedFontSize = fontSize ?? (isSmall ? "0.78rem" : undefined);

  if (isPrimary)
    return (
      <PrimaryBttn
        textBttn={textBttn}
        isDisabled={isDisabled}
        //@ts-ignore
        fontSize={resolvedFontSize}
        //@ts-ignore
        disabled={disabled}
        handleClick={handleClick}
        width={width}
        style={style}
        isLoading={isLoading}
        id={id}
        padding={resolvedPadding}
        buttonProps={buttonProps}
        //@ts-ignore
        size={size}
      />
    );
  return (
    <SecondaryBttn
      textBttn={textBttn}
      fontSize={resolvedFontSize}
      //@ts-ignore
      disabled={disabled}
      loading={isLoading}
      handleClick={handleClick}
      width={width}
      testId={testId}
      color={color}
      padding={resolvedPadding}
      buttonProps={buttonProps}
      id={id}
      //@ts-ignore
      size={size}
    />
  );
};

export default Button;
